export const zeroPadding = (input = 0, width = 4, zero = "0") => {
	const inputString = String(input);
	if (inputString.length >= width) {
		return inputString;
	}
	return (
		new Array(width - inputString.length + 1).join(String(zero)) + inputString
	);
};
